import { Injectable, computed, inject, signal } from '@angular/core';
import { HTTP_LOADING_CONFIG } from './http-loading.config';

@Injectable({ providedIn: 'root' })
export class HttpLoadingService {
  private readonly config = inject(HTTP_LOADING_CONFIG);
  private readonly _activeCount = signal(0);
  private readonly _visible = signal(false);
  private showTimer: ReturnType<typeof setTimeout> | null = null;

  readonly loading = computed(() => this._visible());

  trackStart(): void {
    this._activeCount.update((count) => count + 1);

    if (this._visible() || this.showTimer) {
      return;
    }

    const debounceMs = this.config.debounceMs ?? 0;
    if (debounceMs <= 0) {
      this._visible.set(true);
      return;
    }

    this.showTimer = setTimeout(() => {
      this.showTimer = null;
      if (this._activeCount() > 0) {
        this._visible.set(true);
      }
    }, debounceMs);
  }

  trackEnd(): void {
    this._activeCount.update((count) => Math.max(0, count - 1));

    if (this._activeCount() > 0) {
      return;
    }

    if (this.showTimer) {
      clearTimeout(this.showTimer);
      this.showTimer = null;
    }

    this._visible.set(false);
  }
}
